import { ApplicationRecord } from "./ApplicationRecord";
import { Attr, Model } from "spraypaint";
import { ExtraLocationType } from "../types";

// This is used on Counseling to request address changes, and is also displayed to the user on their AddressesCard
// An address change request might be for a different origin address, or for an additional stop
// Depot has :locations, a superset of :extra_stops, which we used to use here.
// Note that :locations has more fields such as rooms, which we don't need.
@Model()
export class Location extends ApplicationRecord {
  static jsonapiType = "locations";
  @Attr() type!: ExtraLocationType;
  @Attr() streetAddress!: string;
  @Attr() streetAddress2!: string;
  @Attr() city!: string;
  @Attr() state!: string;
  @Attr() postalCode!: string;
  @Attr() country!: string;
  @Attr() timezone!: string;
}

@Model()
export class WarehouseLocation extends Location {
  static jsonapiType = "warehouses";
}

@Model()
export class StorageLocation extends Location {
  static jsonapiType = "storage_locations";
}

@Model()
export class RoomLocation extends Location {
  static jsonapiType = "rooms";
}

@Model()
export class OriginLocation extends Location {
  static jsonapiType = "origin_locations";
}

@Model()
export class DestinationLocation extends Location {
  static jsonapiType = "destination_locations";
}

@Model()
export class ExtraPickupLocation extends Location {
  static jsonapiType = "extra_pickup_locations";
}

@Model()
export class ExtraDropoffLocation extends Location {
  static jsonapiType = "extra_dropoff_locations";
}

@Model()
export class SitDeliveryLocation extends Location {
  static jsonapiType = "sit_delivery_locations";
}

@Model()
export class OriginDutyLocation extends Location {
  static jsonapiType = "origin_duty_locations";
}

@Model()
export class DestinationDutyLocation extends Location {
  static jsonapiType = "destination_duty_locations";
}

@Model()
export class AllowanceDestinationLocation extends Location {
  static jsonapiType = "allowance_destination_locations";
}

@Model()
export class AllowanceOriginLocation extends Location {
  static jsonapiType = "allowance_origin_locations";
}
